module.exports = __webpack_public_path__ + "va.a44c6ba981a68dc7e9cd.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/1x1/va.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/1x1/va.svg
// module chunks = styles